<template>
    <div v-if="user.socialLinks || portfolio.socialLinks"
        :class="['social-links',
                !templateSettings.showProfilePicture ? 'full-w' : '',
                (templateSettings.hero && templateSettings.hero.alignment.horizontal) ? templateSettings.hero.alignment.horizontal : '']"
    >
        <template v-bind:key="socialLink" v-for="(socialLink, index) in filteredSocials">
            <AnimationWrapper
                :animation-style="animationSettings?.animationStyle !== 'NONE' ? 'FADE_IN' : null"
                :delay-animation="0.6 + index * 0.1"
            >
                <template #animationContent>
                    <GetHeroSocialLinkItem :social-link="socialLink" />
                </template>
            </AnimationWrapper>
        </template>
    </div>
</template>

<script>
    import {SocialLinkTypeEnum} from "../../../../common/enums.js";
    import AnimationWrapper from "../../../../common/components/AnimationWrapper.vue";
    import GetHeroSocialLinkItem from "@/scripts/view/portfolio/common/hero/GetHeroSocialLinkItem.vue";
    import {mapGetters} from "vuex";

    export default {
        name: "GetHeroSocialLinks",
        components: {GetHeroSocialLinkItem, AnimationWrapper},
        computed: {
            ...mapGetters("view", ["viewData"]),
            user() {
                return this.viewData.user
            },
            portfolio() {
                return this.viewData.portfolio
            },
            templateSettings() {
                return this.portfolio.templateSettings
            },
            socialLinks() {
                return this.user.socialLinks ? this.user.socialLinks : this.portfolio.socialLinks
            },
            filteredSocials() {
                return this.socialLinks.filter(link => link.url !== "")
            },
            ...mapGetters("design", ["animationSettings"]),
        }
    }
</script>

<style lang="scss" scoped>
@import "@/styles/layouts/new-portfolio-layout/components/social-links";
</style>